import { useUser, UserPlan } from '@/contexts/UserContext';
import { Button } from '@/components/ui/button';
import { Shield } from 'lucide-react';
import { useNavigate, useLocation } from 'react-router-dom';

const plans: { value: UserPlan; label: string }[] = [
  { value: 'light', label: 'Light' },
  { value: 'pro', label: 'Pro' },
  { value: 'avancado', label: 'Avançado' },
];

const PlanSwitcher = () => {
  const { user, setPlan } = useUser();
  const navigate = useNavigate();
  const location = useLocation();

  if (!import.meta.env.DEV || !user) return null;

  const isInAdmin = location.pathname.startsWith('/admin');

  return (
    <div className="fixed bottom-4 right-4 z-50 flex items-center gap-1 rounded-lg border bg-background/95 backdrop-blur p-1.5 shadow-lg">
      <span className="text-[10px] font-display text-muted-foreground px-1.5 hidden sm:inline">Plano:</span>
      {plans.map((p) => (
        <Button
          key={p.value}
          size="sm"
          variant={!isInAdmin && user.plan === p.value ? 'default' : 'ghost'}
          className="h-7 px-2.5 text-xs font-body"
          onClick={() => {
            setPlan(p.value);
            if (!location.pathname.startsWith('/painel')) navigate('/painel');
          }}
        >
          {p.label}
        </Button>
      ))}
      {user.isAdmin && <>
      <div className="w-px h-5 bg-border mx-0.5" />
      <Button
        size="sm"
        variant={isInAdmin ? 'default' : 'ghost'}
        className="h-7 px-2.5 text-xs font-body gap-1"
        onClick={() => navigate(isInAdmin ? '/painel' : '/admin')}
      >
        <Shield className="h-3.5 w-3.5" />
        Admin
      </Button>
      </>}
    </div>
  );
};

export default PlanSwitcher;
